import styled from 'styled-components';

export const Container = styled.footer`
    background: #000000;
    height: 200px;
    padding: 50px 10px 10px 10px;

    section {
        display: flex;
        justify-content: space-evenly;
        div {
            width: 60%;
            &:nth-child(1) {
                width: 200px;
            }
            h1 {
                font-family: Arial, Helvetica, sans-serif;
                color: var(--strong-pink);
                font-size: 24px;
                margin-bottom: 10px;

                &::after {
                    content: '';
                    width: 100px;
                    height: 5px;
                    margin-top: 5px;
                    margin-bottom:15px;

                    background: var(--brown);
                    display: block;
                }
            }
            ul {
                li {
                    font-size: 16px;
                    margin-top: 5px;
                    font-family: Arial, Helvetica, sans-serif;
                    color: var(--white);
                    a {
                        color: var(--white);
                        transition: 0.3s;
                        &:hover {
                            color: var(--light-pink);
                        }
                    }
                }
            }
        }   
    }   

    > div {
        padding: 10px;
        h3 {
            text-align: center;
            font-family: Arial, Helvetica, sans-serif;
            color: var(--white);
            span {
                color: red;
            }
        }
    }
`;